
export default class Constants {
  static SUSCEPTIBLE_COLOR = '#EEE';
  static EXPOSED_COLOR = '#ffdde2';
  static INFECTED_COLOR = '#F44';
  static ISOLATING_COLOR = '#8094ff';
  static REMOVED_COLOR = '#999';
  static DEAD_COLOR = '#000';

  static SUSCEPTIBLE = 0;
  static EXPOSED = 1;
  static INFECTED = 2;
  static REMOVED = 3;
  static DEAD = 4;
}